import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
// import './stylus/main.styl';

import './css/bootstrap.min.css';
import './css/style.css';

import BlockUI from 'vue-blockui';
import VueCookies from 'vue-cookies';


//Imported components
Vue.use(BlockUI);
Vue.use(VueCookies);


new Vue({
  render: h => h(App),
  store,
  router,
  vuetify,

  data() {
    return {
      blockUIshow: false,
      blockUImsg: null,
      fullScreenView: false
    }
  },
}).$mount('#app');